import { Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { useTranslation } from "react-i18next";
import ResponsiveCharts from "../ChartsLayout/ResponsiveCharts.jsx";
import { BarChartEmptyComponent } from "../ChartsLayout/EmptyCharts.jsx";
import { labelMappings } from "./chartUtilies.js";

export default function DistributionBarChartComponent({
  data,
  title,
  color,
  tKeyPrefix,
  mappings = labelMappings,
}) {
  const isEmpty = !data || Object.keys(data).length === 0;
  // console.log("Bar chart data: ", `${tKeyPrefix}`, data);
  const { t } = useTranslation("homepage");
  const chartData = isEmpty
    ? []
    : Object.entries(data).map(([rawLabel, value], index) => {
        const normalized = String(rawLabel).toLowerCase().trim();
        const token = (
          mappings[rawLabel] ??
          mappings[normalized] ??
          normalized
        ).toLowerCase();
        const key = tKeyPrefix ? `${tKeyPrefix}.${token}` : token;

        const translated = t(key, { defaultValue: "" });
        const label = translated || rawLabel;

        return { id: index, value, label };
      });

  const labels = chartData.map((entry) => entry.label);
  const values = chartData.map((entry) => entry.value);

  return (
    <ResponsiveCharts>
      {({ chartWidth }) =>
        isEmpty ? (
          <>
            {title && (
              <Typography
                variant="h6"
                sx={{ textAlign: "center", marginBottom: "10px" }}
              >
                {title}
              </Typography>
            )}
            <BarChartEmptyComponent
              chartWidth={chartWidth}
              height={300}
              title={title}
            />
          </>
        ) : (
          <>
            {title && (
              <Typography
                variant="h6"
                sx={{ textAlign: "center", marginBottom: "10px" }}
              >
                {title}
              </Typography>
            )}
            <BarChart
              xAxis={[{ scaleType: "band", data: labels }]}
              series={[{ data: values, color: color }]}
              width={chartWidth}
              height={300}
            />
          </>
        )
      }
    </ResponsiveCharts>
  );
}
